export enum ArticleActions {
  RenameArticle = 'RENAME_LESSON_OR_SECTION',
  SaveArticleCustomDuration = 'SAVE_LESSON_CUSTOM_DURATION',
  SetArticleCover = 'SET_LESSON_COVER',
  Back = 'BACK',
}
